import React, {forwardRef, KeyboardEvent, RefObject, useCallback, useEffect, useImperativeHandle, useRef} from 'react'

import {ENTITY_SELECTOR_MENU_HEIGHT, ENTITY_SELECTOR_SEARCH_HEIGHT, EntitySelectorListType} from "../../selector"
import TaskFinder from "../../../finder/task/task-finder"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import {EntityType} from "../../../../gd/const/item"
import {SystemStatusFilter} from "../../../finder/task/@types";

type Props = {
    search              : string
    listType            : EntitySelectorListType

    parentProjectId?    : ID
    excludedTasksIds?   : ID[]

    onEntitySelected    : {(entity:MentionOption):void}
    onTab               : {():void}
}

const debug = false
// const debug = "EntitySelectorTasksList"

const EntitySelectorTasksList = forwardRef((props:Props, ref) => {
    debug && console.log(debug, 'render', props)

    const taskFinderRef:RefObject<any> = useRef()

    const searchString = props.search?.toLowerCase()

    useEffect(() => {
        taskFinderRef.current?.onSearchChange(searchString)
    }, [searchString]);

    useEffect(() => {
        taskFinderRef.current?.onSearchCancel()
    }, [props.listType]);

    const onKeyDown = useCallback((event:KeyboardEvent) => {
        taskFinderRef.current.onKeyDown(event)
    }, [])

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        onKeyDown,
    }))

    const onClickTask = useCallback((task: any)=>{
        const option = new MentionOption({
            id  : task.id,
            name: task.title,
            type: EntityType.TASK,
            data: task
        })

        debug && console.log(debug, 'onClickTask', option)

        props.onEntitySelected(option)
    }, [])

    debug && console.log(debug, 'render', props)

    const styles = {
        height: `calc(100% - ${ENTITY_SELECTOR_MENU_HEIGHT + ENTITY_SELECTOR_SEARCH_HEIGHT}px)`
    }

    const showRecentTasks = !props.search && props.listType === EntitySelectorListType.RECENT

    debug && console.log(debug, 'render', showRecentTasks, props)

    return (
        <div className="entity-selector-list" style={styles}>
            <TaskFinder ref                 = {taskFinderRef}
                        noHeader            = {true}
                        showRecent          = {showRecentTasks}
                        parentProjectId     = {props.parentProjectId}
                        excludedTasksIds    = {props.excludedTasksIds}
                        onClickTask         = {onClickTask}
                        onTab               = {props.onTab}
                        systemStatusFilter  = {SystemStatusFilter.ALL} />
        </div>
    )
})

export default EntitySelectorTasksList
